import { useState } from "react";
import { format } from "date-fns";
import { CalendarIcon, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const toISO = (d) => (d ? format(d, "yyyy-MM-dd") : "");

export function DateRangePicker({ start, end, onChange, testid = "date-range", disabled = false }) {
  const [open, setOpen] = useState(false);
  const range = {
    from: start ? new Date(start + "T00:00:00") : undefined,
    to: end ? new Date(end + "T00:00:00") : undefined,
  };

  const label = disabled
    ? "Not applicable"
    : range.from
    ? range.to
      ? `${format(range.from, "dd MMM yyyy")} — ${format(range.to, "dd MMM yyyy")}`
      : format(range.from, "dd MMM yyyy")
    : "All dates";

  return (
    <div className="relative">
      <Popover open={disabled ? false : open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button variant="outline" data-testid={`${testid}-trigger`} disabled={disabled}
            className={`w-full justify-start gap-2 border-brand-line rounded-sm font-normal text-brand-text ${range.from && !disabled ? "pr-9" : ""} disabled:opacity-50 disabled:cursor-not-allowed`}>
            <CalendarIcon className="w-4 h-4 text-brand-muted shrink-0" />
            <span className="truncate">{label}</span>
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0 bg-white border-brand-line" align="start" data-testid={`${testid}-calendar`}>
          <Calendar
            mode="range"
            numberOfMonths={2}
            selected={range}
            defaultMonth={range.from}
            onSelect={(r) => onChange({ start: toISO(r?.from), end: toISO(r?.to) })}
          />
        </PopoverContent>
      </Popover>
      {range.from && !disabled && (
        <button type="button" data-testid={`${testid}-clear`}
          onClick={() => onChange({ start: "", end: "" })}
          className="absolute right-2 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center rounded-sm text-brand-muted hover:text-brand-alert hover:bg-brand-bg">
          <X className="w-3.5 h-3.5" />
        </button>
      )}
    </div>
  );
}
